




















import { BreadCrumb } from "@/store/modules/GlobalStore";
import { Component } from "vue-property-decorator";
import BasePage from "../base/BasePage";

@Component
export default class extends BasePage {
  title = "Page Not Found";
  breadCrumbs = [new BreadCrumb("Page Not Found")];
}
